import React, { useState, useEffect } from "react";

function CustomCaptcha() {
  const [captcha, setCaptcha] = useState({});
  const [userInput, setUserInput] = useState("");
  const [isValid, setIsValid] = useState(false);

  // captcha generate
  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptcha({ num1, num2, answer: num1 + num2 });
    setUserInput("");
    setIsValid(false);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <div className="mb-3">
      {/* <label className="form-label">Captcha</label> */}
      <div className="input-group" style={{ maxWidth: "250px" }}>
        <span className="input-group-text">
          {captcha.num1} + {captcha.num2} =
        </span>
        <input
          type="number"
          className="form-control"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          placeholder="?"
          required
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={generateCaptcha}
        >
          ↻
        </button>
      </div>
    </div>
  );
}

export default CustomCaptcha;
